import isFinite from 'lodash/isFinite';

const ZERO_CHAR_CODE = '0'.charCodeAt(0);
const NINE_CHAR_CODE = '9'.charCodeAt(0);
const DECIMAL_DOT_CHAR_CODE = '.'.charCodeAt(0);
const MINUS_DOT_CHAR_CODE = '-'.charCodeAt(0);

export const isDigit = (string) => {
  if (string.length !== 1) {
    return false;
  }
  const charCode = string.charCodeAt(0);
  return charCode >= ZERO_CHAR_CODE && charCode <= NINE_CHAR_CODE;
};

export const isDecimalDot = (string) => {
  if (string.length !== 1) {
    return false;
  }
  return string.charCodeAt(0) === DECIMAL_DOT_CHAR_CODE;
};

export const isMinus = (string) => {
  if (string.length !== 1) {
    return false;
  }
  return string.charCodeAt(0) === MINUS_DOT_CHAR_CODE;
};

export const extractFirstLongestNumberFromString = (
  string,
  includeNegative = false,
  includeDecimalDot = false,
  allowPartials = false,
) => {
  let i = 0;
  const charArray = string.split('');
  const beginIndices = charArray.map(() => Infinity);
  const decimalDotBeginIndices = charArray.map(() => Infinity);
  const n = charArray.length;
  let maxLength = 0;
  let bestBegin = 0;
  let lm1;

  if (n > 0 && isDigit(charArray[0])) {
    beginIndices[0] = 0;
    maxLength = 1;
  }

  for (i = 1; i < n; i += 1) {
    if (isDigit(charArray[i])) {
      if (isFinite(beginIndices[i - 1])) {
        beginIndices[i] = beginIndices[i - 1];
      } else {
        beginIndices[i] = i;
        if (includeNegative && isMinus(charArray[i - 1])) {
          beginIndices[i] -= 1;
        }
      }
    }
    if (includeDecimalDot && isDecimalDot(charArray[i])) {
      decimalDotBeginIndices[i] = beginIndices[i - 1];
    }
    const previous = beginIndices[i] - 1;
    if (isFinite(previous) && previous > 0 && isFinite(decimalDotBeginIndices[previous])) {
      lm1 = i - decimalDotBeginIndices[previous];
      if (lm1 + 1 > maxLength) {
        maxLength = lm1 + 1;
        bestBegin = decimalDotBeginIndices[previous];
      }
    }
    lm1 = i - beginIndices[i];
    if (lm1 + 1 > maxLength) {
      maxLength = lm1 + 1;
      bestBegin = beginIndices[i];
    }

    lm1 = i - decimalDotBeginIndices[i];
    if (allowPartials && lm1 + 1 > maxLength) {
      maxLength = lm1 + 1;
      bestBegin = decimalDotBeginIndices[i];
    }
  }
  return charArray.slice(bestBegin, bestBegin + maxLength).join('');
};
